module.exports = function getResource(label, vars = []) {
    let resources = {
        viewNumber: `View ${vars[0]}`,
        viewAll: 'View all'
    };
    return resources[label];
};
